// extracted by mini-css-extract-plugin
export var educationBanner = "index-module--educationBanner--ojXec";
export var educationBannerInner = "index-module--educationBannerInner--lxAyG";
export var educationBannerLink = "index-module--educationBannerLink--Z-w2s";
export var educationBannerRegion = "index-module--educationBannerRegion--5Hkpt";